// 配置全局访问接口地址
let commonUrl = "https://zjp-wxsh.qpl-001.site";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl